import PropTypes from 'prop-types';

export default PropTypes.shape({
  isCash: PropTypes.bool,
  price: PropTypes.number.isRequired,
  reportedBy: PropTypes.string,
  postedTime: PropTypes.string,
});
